import React from 'react'
import PropTypes from 'prop-types'
import SydBadge from '../../../../commonDesign/SydBadge'

function NotificationStatusBadge ({ value }) {
  const enabled = value !== false

  if (enabled) {
    return (
      <SydBadge size='xs' variant='success'>Receives notifications</SydBadge>
    )
  }

  return (
    <SydBadge size='xs' variant='neutral'>Notifications off</SydBadge>
  )
}

NotificationStatusBadge.propTypes = {
  value: PropTypes.bool
}

NotificationStatusBadge.defaultProps = {
  value: true
}

export default NotificationStatusBadge
